import React, { FC } from 'react'

import s from './LogoHeader.module.scss'

type Props = {
  logoUrl: string
}

const LogoHeader: FC<Props> = ({ logoUrl }) => {
  return (
    <div className={s.LogoHeader}>
      <img src={logoUrl} alt="" />
      <div />
    </div>
  )
}

export default LogoHeader
